import { convertToKebabCase, normalizeAccent } from '@bitComponents/utils/htmlUtils';
import { commonTypes } from './common';

export const types = {
  SET_ALIAS_SELLING_PRODUCT: 'TAGGING/SET_ALIAS_SELLING_PRODUCT',
  SET_DOWNGRADES_ALIAS: 'TAGGING/SET_DOWNGRADES_ALIAS',
  SET_MANUAL_PRODUCT_OFFERING: 'TAGGING/SET_MANUAL_PRODUCT_OFFERING',
  SET_CQ: 'TAGGING/SET_CQ',
  SET_CO: 'TAGGING/SET_CO',
  SET_ZIP_CODE: 'TAGGING/SET_ZIP_CODE',
  SET_SELECT_ELEMENTS_CHOICES: 'TAGGING/SET_SELECT_ELEMENTS_CHOICES',
  SET_PRICES_FINAL_CHOICES: 'TAGGING/SET_PRICES_FINAL_CHOICES',
};

export const initialState = {
  aliasSellingProduct: null, // parametro
  downgradesAlias: null,
  allPOsToBuy: [], // array de POs
  allPOsToDowngrade: [], // array de POs
  allPromosId: [], //
  choices: '',
  co: null, // co
  cq: null, // cq
  zipCode: '',
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const TaggingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ALIAS_SELLING_PRODUCT: {
      const { alias } = action.payload;

      if (alias) {
        return {
          ...state,
          aliasSellingProduct: convertToKebabCase(normalizeAccent(alias)),
        };
      }

      return {
        ...state,
      };
    }
    case types.SET_DOWNGRADES_ALIAS: {
      const { alias } = action.payload;

      if (alias) {
        return {
          ...state,
          downgradesAlias: convertToKebabCase(normalizeAccent(alias)),
        };
      }

      return {
        ...state,
      };
    }
    case commonTypes.SET_OFFER_INFO: {
      const {
        allPOsToBuy,
        poR,
        storageId,
        colorId,
        productOfferingsToUpgrade,
        productOfferingsToDowngrade,
        netflixToDowngrade
      } = action.payload;

      let newAllPOsToBuy = [...allPOsToBuy];
      if(storageId && colorId){
        if (allPOsToBuy && allPOsToBuy.length === 1) {
          let completeDevicePO = newAllPOsToBuy[0];
  
          completeDevicePO = `${completeDevicePO}_${storageId}_${colorId}`;
  
          newAllPOsToBuy = [completeDevicePO];
        } else if (poR){
          newAllPOsToBuy.forEach((poToBuy, index) => {
            if (poToBuy === poR) {
              newAllPOsToBuy[index] = `${poToBuy}_${storageId}_${colorId}`;
            }
          });
        }
      }
      if(productOfferingsToUpgrade){
        newAllPOsToBuy = [...allPOsToBuy, ...productOfferingsToUpgrade];
      }
      let allPOsToDowngrade = [];
      if(productOfferingsToDowngrade){
        allPOsToDowngrade = [...productOfferingsToDowngrade];
      }
      if(netflixToDowngrade){
        allPOsToDowngrade = [...allPOsToDowngrade, netflixToDowngrade];
      }

      return {
        ...state,
        allPOsToBuy: newAllPOsToBuy || [],
        allPOsToDowngrade: allPOsToDowngrade || [],
      };
    }
    case commonTypes.SET_SELECT_ELEMENTS_NEEDS: {
      const {
        newAllPOsToBuy,
      } = action.payload;
      if(newAllPOsToBuy){
        return {
          ...state,
          allPOsToBuy: newAllPOsToBuy,
        };
      } else {
        return {
          ...state,
        };
      }
    }
    case types.SET_MANUAL_PRODUCT_OFFERING: {
      const {
        productOffering,
      } = action.payload;

      return {
        ...state,
        allPOsToBuy: [productOffering, ...state.allPOsToBuy],
      };
    }
    case commonTypes.SET_ALL_PROMOS_ID: {
      const { allPromos } = action.payload;

      if (allPromos) {
        const newPromosId = state.allPromosId;

        if (Array.isArray(allPromos)) {
          newPromosId.push(...allPromos);
        } else {
          newPromosId.push(allPromos);
        }

        return {
          ...state,
          allPromosId: newPromosId,
        };
      }

      return {
        ...state,
      };
    }
    case types.SET_CQ: {
      const { cq } = action.payload;

      return {
        ...state,
        cq,
      };
    }
    case types.SET_CO: {
      const { co } = action.payload;

      return {
        ...state,
        co,
      };
    }
    case commonTypes.SET_SE_INFO: {
      const { idSE } = action.payload;

      return {
        ...state,
        idSE,
      };
    }
    case types.SET_ZIP_CODE: {
      const { zipCode } = action.payload;

      if (zipCode) {
        return {
          ...state,
          zipCode,
        };
      }

      return { ...state };
    }
    case types.SET_SELECT_ELEMENTS_CHOICES: {
      const { choices } = action.payload;
      const newChoices = state.choices ? `${state.choices}:${choices}` : choices;
      sessionStorage.setItem('choices', newChoices);
      return {
        ...state,
        choices: newChoices,
      };
    }
    case types.SET_PRICES_FINAL_CHOICES: {
      const { choices } = action.payload;
      if(!state.choices){
        sessionStorage.setItem('choices', choices);
        return {
          ...state,
          choices,
        };
      }
      return { ...state };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  setAliasSellingProduct: alias => ({
    type: types.SET_ALIAS_SELLING_PRODUCT,
    payload: {
      alias,
    },
  }),
  setDowngradesAlias: alias => ({
    type: types.SET_DOWNGRADES_ALIAS,
    payload: {
      alias,
    },
  }),
  setCQ: cq => ({
    type: types.SET_CQ,
    payload: {
      cq,
    },
  }),
  setCO: co => ({
    type: types.SET_CO,
    payload: {
      co,
    },
  }),
  setZipCode: zipCode => ({
    type: types.SET_ZIP_CODE,
    payload: {
      zipCode,
    },
  }),
  setSelectElementsChoices: choices => ({
    type: types.SET_SELECT_ELEMENTS_CHOICES,
    payload: {
      choices,
    },
  }),
  setPricesFinalChoices: choices => ({
    type: types.SET_PRICES_FINAL_CHOICES,
    payload: {
      choices,
    },
  }),
  setManualProductOffering: offerInfo => ({
    type: types.SET_MANUAL_PRODUCT_OFFERING,
    payload: {
      ...offerInfo,
    },
  }),
};

export default TaggingReducer;
